(function () {
  function boot() {
    var bar = document.querySelector('[data-pv-sticky]');
    if (!bar || bar.dataset.pvReady) return;
    var mainBtn = document.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[name="add"]');
    if (!mainBtn) return;
    bar.dataset.pvReady = 'true';
    var stickyBtn = bar.querySelector('[data-pv-sticky-btn]');
    var priceEl = bar.querySelector('[data-pv-sticky-price]');
    var mainPrice = document.querySelector('[id^="price-template"], [id^="price-"]');

    function show(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyBtn.tabIndex = visible ? 0 : -1;
      document.body.classList.toggle('pv-sticky-open', visible);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        show(!e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainBtn);
    }

    function sync() {
      stickyBtn.disabled = mainBtn.disabled;
      stickyBtn.textContent = mainBtn.disabled ? bar.dataset.labelSoldout : bar.dataset.labelAdd;
      if (mainPrice && priceEl) {
        var priceBox = mainPrice.querySelector('.price');
        var onSale = priceBox && priceBox.classList.contains('price--on-sale');
        var item = onSale
          ? mainPrice.querySelector('.price__sale .price-item--sale')
          : mainPrice.querySelector('.price__regular .price-item--regular');
        if (item && item.textContent.trim()) priceEl.textContent = item.textContent.trim();
      }
    }

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(sync);
      mo.observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
      if (mainPrice) mo.observe(mainPrice, { childList: true, subtree: true, characterData: true });
    }

    stickyBtn.addEventListener('click', function () {
      if (mainBtn.disabled) return;
      mainBtn.click();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
